/**
 * ForecastsRequest
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import { requestloadQuantityForecasts } from '../../../../../../services/quantityForecasts/actions';

// Selectors
import { selectCurrentEntityId } from '../../../../../../services/currentEntityId/selectors';
import { selectCurrentSeasonId } from '../../../../../../services/currentSeasonId/selectors';

// Workspaces
import { selectTime } from '../../../../../../workspaces/redux-timekeeper';

interface Props {
    time?: string;
    currentSeasonId?: ?number;
    requestloadQuantityForecasts: Function;
    currentEntityId?: ?number;
}

export class ForecastsRequest extends React.PureComponent<Props> {
    static defaultProps = {
        time: undefined,
        currentSeasonId: null,
        currentEntityId: null
    };

    componentDidMount() {
        this.requestloadQuantityForecasts();
    }

    componentDidUpdate(prevProps: Props) {
        // Update if current season changes
        if (
            prevProps.currentSeasonId !== this.props.currentSeasonId ||
            prevProps.currentEntityId !== this.props.currentEntityId
        ) {
            this.requestloadQuantityForecasts();
        }
    }

    requestloadQuantityForecasts = () => {
        const { currentSeasonId, currentEntityId } = this.props;
        if (currentSeasonId) {
            this.props.requestloadQuantityForecasts(
                currentSeasonId,
                currentEntityId
            );
        }
    };

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    time: selectTime,
    currentEntityId: selectCurrentEntityId,
    currentSeasonId: selectCurrentSeasonId
});

export default connect(
    mapStateToProps,
    { requestloadQuantityForecasts }
)(ForecastsRequest);
